module.exports = __webpack_public_path__ + "media/images/categories/headers/companies-75ac8eb0f0307d0b43e5acea03215bfe.jpg";